/** Gemeinsame Zeitdarstellung für Journal und Aufgaben. */

export function relativeZeit(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';

  const jetzt = new Date();
  const tagStart = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const tage = Math.round((tagStart(jetzt) - tagStart(d)) / 86400000);
  const uhr = d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });

  if (tage === 0) return `heute ${uhr}`;
  if (tage === 1) return `gestern ${uhr}`;
  if (tage === -1) return `morgen ${uhr}`;
  if (tage > 1 && tage < 7) return `vor ${tage} Tagen`;
  if (tage < -1 && tage > -7) return `in ${Math.abs(tage)} Tagen`;
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }) + ` ${uhr}`;
}

export function istUeberfaellig(iso?: string | null): boolean {
  if (!iso) return false;
  const d = new Date(iso);
  return !Number.isNaN(d.getTime()) && d.getTime() < Date.now();
}
